import * as v from 'valibot';

// * menus
const menusItemSchema = v.object({
  domain: v.union([
    v.literal('bh-kiss-first-level'),
    v.literal('bh-kiss-second-level'),
    v.literal('bh-kiss-info'),
    v.literal('bh-kiss-topics'),
    v.literal('bh-kiss-socials'),
    v.literal('bh-kiss-footer-info'),
    v.literal('bh-kiss-footer-subs'),
    v.literal('bh-kiss-footer-rules'),
  ]),
  name: v.string(),
  items: v.array(
    v.object({
      id: v.number(),
      title: v.string(),
      link: v.string(),
      // * null | string
      color_picker: v.nullable(v.string()),
      color_text: v.nullable(v.string()),
      test_pixel: v.nullable(v.string()),
      color_archive: v.nullable(v.string()),
    }),
  ),
});

export const menusSchema = v.object({
  items: v.array(menusItemSchema),
});
